import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ChatReplyTargetInvalidationEvent {
  chatId: number;
  messageId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatReplyTargetInvalidationService {
  private readonly targetDeletedSubject = new Subject<ChatReplyTargetInvalidationEvent>();
  public readonly targetDeleted$: Observable<ChatReplyTargetInvalidationEvent> = this.targetDeletedSubject.asObservable();

  public notifyTargetDeleted(chatId: number | null | undefined, messageId: string | null | undefined): void {
    const normalizedChatId = this.normalizeChatId(chatId);
    const normalizedMessageId = this.normalizeMessageKey(messageId);
    if (normalizedChatId === null || normalizedMessageId === null) return;

    this.targetDeletedSubject.next({
      chatId: normalizedChatId,
      messageId: normalizedMessageId,
    });
  }

  private normalizeChatId(chatId: number | null | undefined): number | null {
    if (!Number.isInteger(chatId) || chatId === null || chatId === undefined || chatId < 1) {
      return null;
    }

    return chatId;
  }

  private normalizeMessageKey(value: string | number | null | undefined): string | null {
    if (value === null || value === undefined) return null;
    const normalized = String(value).trim();
    return normalized.length > 0 ? normalized : null;
  }
}
